

import React, { useContext, useRef, useState } from 'react';
import IconClose from '../../assets/images/IconClose';
import OfferBanner from '../OfferBanner';
import { AlertWrapper } from '../UI/styledConstants';
import { Wrapper } from '../Electricity/style';
import { isEmpty } from '../../utils/common';
import Loader from '../UI/Loader/Loader';
import { cancelDqr, checkStatusDqr, createDqr } from '../../utils/api';
import { GlobleContaxt } from '../../Context/GlobleContaxt';
import Timer from '../Addmoney/Timer';

const initialControls = {
    amount:"",
    mobile:"",
    email:"",
}

function DQRpage() {
    const [message, setMessage] = useState({});
    const [controls, setControls] = useState({ ...initialControls });
    const [activeMobilePop, setActiveMobilePop] = useState(false);
    const [loading, setLoading] = useState(false);
    

    const timerId = useRef();

    const {setAlert} = useContext(GlobleContaxt);

    const numberReg = /^[0-9]+$/;
	const amountReg = /^[0-9.]+$/;
	const emailReg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const onChangeHandler =(e)=>{
          const name =  e.target.name;
          const value =  e.target.value;
        if (name === 'mobile') {
			if (!numberReg.test(value) && value) {
				return false;
			}
		}
		if (name === 'amount') {
			if (!amountReg.test(value) && value) {
				return false;
			}
		}


        setControls({...controls,[name]:value});
        setMessage({});
    }


    const submit = () =>{

        if(controls.amount === '' && !controls.amount){
            setMessage({ type: 'error', msg: 'Please enter amount', place: 'form' });
            return;
        }
        if (controls.mobile.length < 10) {
            setMessage({ type: 'error', msg: 'Please enter valid mobile number', place: 'form' });
            return;
        } 
     if (!emailReg.test(controls.email)) {
        setMessage({ type: 'error', msg: 'Please enter valid email', place: 'form' });
        return;
     } 

     const param = {
        customerEmail: controls.email,
        customerMobileNumber:controls.mobile,
        amount:controls.amount
     }
   
     createDqr(param).then((resp) =>{
   
        if (resp?.success) {
            setControls({...initialControls});
            checkStatus("240906111335251E020053983")
        } else {
            checkStatus("240906111335251E020053983")
          
            if (resp?.errorCodeList.length > 0) {
                setAlert({ type: 'error', msg: resp?.errorCodeList[0]});
            } else {
                setAlert({ type: 'error', msg: resp?.msg});
            }
        }
     })

    }

    const cancel = () =>{
        const param = {
            origP2pRequestId: "240906111335251E020053983"
         }
       
         cancelDqr(param).then((resp) =>{
       
            if (resp?.success) {
            } else {
                if (resp?.errorCodeList.length > 0) {
                    setAlert({ type: 'error', msg: resp?.errorCodeList[0]});
                } else {
                    setAlert({ type: 'error', msg: resp?.msg});
                }
            }
         })
    }

    const checkStatus = (id) =>{
        const param = {
            origP2pRequestId: id
         }
       
         checkStatusDqr(param).then((resp) =>{
       
            if (resp?.success) {


                timerId.current =  setTimeout(() =>{
                    checkStatus(id);
                },3000);

            } else {
                clearTimeout(timerId.current);
                if (resp?.errorCodeList.length > 0) {
                    setAlert({ type: 'error', msg: resp?.errorCodeList[0]});
                } else {
                    setAlert({ type: 'error', msg: resp?.msg});
                }
            }
         })
    }

   
	return (
		<Wrapper className={`tab-content-wrapper`}>
			{!isEmpty(message) && message.place == 'globle' && (
				<AlertWrapper className={`${message.type} globle`}>
					<span className="close" onClick={() => setMessage({})}>
						×
					</span>
					{message.msg}
				</AlertWrapper>
			)}
			<div className="tab-content-left">
				<div className='flex justify-between headingText'  >
					<h2 className=''>Dynamic QR</h2>
			<Timer setTimeover={()=>{}} time={150} />
				</div>
		
				<div className="form-field">
					<input type="text" name="amount" placeholder="Amount" inputMode="numeric" value={controls?.amount} onChange={onChangeHandler} />
				</div>
				<div className="form-field">
					<input type="text" name="mobile" placeholder="Mobile Number" maxLength={10} inputMode="numeric" value={controls?.mobile} onChange={onChangeHandler} />
				</div>
				<div className="form-field">
					<input type="text" name="email" placeholder="Enter email"  value={controls?.email} onChange={onChangeHandler} />
				</div>
				
				{!isEmpty(message) && message.place == 'form' && (
					<AlertWrapper className={message.type}>
						<span className="close" onClick={() => setMessage({})}>
							×
						</span>
						{message.msg}
					</AlertWrapper>
				)} 
				<button type="submit" className="button-outline" onClick={submit}>
					Continue
				</button>
			
			</div>
			<div className={`tab-content-right ${!activeMobilePop ? '' : 'active'}`}>
				<div
					className="d-m-block close-pop"
					onClick={() => {
						setActiveMobilePop(false);
					}}
				>
					<IconClose />
				</div>
		
				{!loading && <OfferBanner />}
			</div>

			{/* {!isEmpty(payDaital) && <ElectricityReceipt payDaital={payDaital} onCloseModal={onCloseModal} />} */}
			{loading && <Loader />}
		</Wrapper>
	);
}

export default DQRpage